var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.errors.length)?_c('div',{staticClass:"errors"},[_c('ul',_vm._l((_vm.errors),function(error,index){return _c('li',{key:("error-" + index)},[_vm._v(_vm._s(error))])}),0)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }